
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"

export default defineComponent({
  components: {},
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("商城订单列表", ["商城订单管理;mall_orders"])
    })

    const store = useStore()
    const tableData = ref([])

    const formData = ref({
      order_no: '',
      user_nickname: '',
      user_mobile: '',
      product_name: '',
      status: '',
      is_presale: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const query = () => {
      store
        .dispatch(Actions.GET_MALL_ORDERS, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentMallOrders
          page.value.totalResult = store.getters.currentMallOrderCount
        })
        .catch(() => {
          console.error('获取订单列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      query()
    }

    const onReset = () => {
      formData.value = {
        order_no: '',
        user_nickname: '',
        user_mobile: '',
        product_name: '',
        status: '',
        is_presale: ''
      }
      page.value.currentPage = 1
      query()
    }

    const onExport = () => {
      ElMessage.info('正在导出...')
      store
        .dispatch(Actions.DOWNLOAD_MALL_ORDERS, { ...formData.value })
        .then(() => {
          const blob = store.getters.currentDownloadMallOrders
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `商城订单_${new Date().toISOString().slice(0, 10)}.xlsx`
          link.click()
          window.URL.revokeObjectURL(url)
          ElMessage.success('导出成功')
        })
        .catch(() => {
          ElMessage.error('导出失败')
        })
    }

    const getStatusType = (status: string) => {
      const statusMap: Record<string, string> = {
        pending_payment: 'warning',
        deposit_paid: 'info',
        pending_shipment: 'primary',
        shipped: '',
        completed: 'success',
        cancelled: 'info',
        refunded: 'danger'
      }
      return statusMap[status] || ''
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      onExport,
      getStatusType,
      formatPrice
    }
  },
})
